import { createContext, useContext, useEffect, useState } from "react";
import PrivateApi from "../services/PrivateApiService";

const HwEmployeeContext = createContext();

export const HwEmployeeProvider = ({ children }) => {
    const API = new PrivateApi();
    const [hwEmployee, setHwEmployee] = useState();
    const [allHwEmployees, setAllHwEmployees] = useState([]);
    const [hwEmployeeLoading, setHwEmployeeLoading] = useState(true);

    useEffect(() => {
        const selectedEmployee = localStorage.getItem("hwEmployee");
        const employeesSaved = localStorage.getItem("hwEmployees");

        if (selectedEmployee !== null) {
            setHwEmployee(JSON.parse(selectedEmployee));
        }

        if (employeesSaved) {
            setAllHwEmployees(JSON.parse(employeesSaved));
            setHwEmployeeLoading(false);
            return;
        }

        const fetchEmployees = async () => {
            API.get_Partner_employees()
                .then(res => {
                    setAllHwEmployees(res.data);
                    localStorage.setItem("hwEmployees", JSON.stringify(res.data));
                })
                .catch(err => {})
                .finally(() => { setHwEmployeeLoading(false); })
        }

        fetchEmployees();
    }, []);

    return (
        <HwEmployeeContext.Provider value={{ hwEmployee, allHwEmployees, hwEmployeeLoading}}>
            {children}
        </HwEmployeeContext.Provider>
    );
};

export const useHwEmployees = () => useContext(HwEmployeeContext);